var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgForwardArrowMinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 34 34"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  x: 1,
  y: 1,
  fill: "#0E5741",
  rx: 16
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 0.6,
  d: "M7.67055 4C10.2968 2.11192 13.5186 1 17 1C25.8366 1 33 8.16344 33 17C33 25.8366 25.8366 33 17 33C8.16344 33 1 25.8366 1 17C1 15.6188 1.17501 14.2785 1.50407 13",
  className: "button-arrow-fill"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 0.75,
  d: "M16.9991 21L20.9991 17M20.9991 17L16.9991 13M20.9991 17H13",
  className: "button-arrow"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 0.75,
  d: "M16.9991 21L20.9991 17M20.9991 17L16.9991 13M20.9991 17H13",
  className: "button-arrow-alt"
})));
export default SvgForwardArrowMinline;